import React from 'react';

// Simplified team provider that just passes through children
// All team state is now managed in useAuthState
export const TeamProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export { useCurrentTeam } from '@/hooks/useTeams';